import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel, HeaderList } from '../../utilitymodels/base.model';

export class SIPOpportuinityItem {
    name: string;
    img: string;
    url: string;
    investorList?: [];
    schemeList?: [];
    data: [];
    text: string;
    remText?: string;
    pageTitle: string;
    toolTipData: string;
    headerList: HeaderList[] = [];
    rowList: string[] = [];
    actionName: string;
    deepLink: boolean;
}

const sipUrl = {
    ceased: NavigateRoutes.sipOpportunityList + '/ceased',
    notrenewed: NavigateRoutes.sipOpportunityList + '/notrenewed',
    maturity: NavigateRoutes.sipOpportunityList + '/maturity',
    rejected: NavigateRoutes.sipOpportunityList + '/rejected',
    lumpsum: NavigateRoutes.crossSellOpportunityList + '/lumpsum',
};

export class SIPOpportunityModel extends BaseDataModel {
    errorModel: any[] = [];
    listInfo: SIPOpportuinityItem[] = [
        {
            name: 'SIP',
            img: 'assets/icon/transaction/SIP.svg',
            data: [],
            url: sipUrl.ceased,
            text: 'Ceased',
            pageTitle: 'Ceased SIP',

            toolTipData: 'This report helps you with the list of investors whose SIPs ceased in the last 2 months',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Cease Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'SIP Amount',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Installment pending',
                    logo: 'assets/icon/card/pending-time-money.svg',
                },
                {
                    name: 'Total Invt. Amt.',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Scheme_Name', 'Cease_Date', 'Sip_Amount', 'Installments_Pending', 'Investment_Amount'],
            actionName: 'RESTART SIP',
            deepLink: false,
        },
        {
            name: 'SIP',
            img: 'assets/icon/dashboard/sipnotrenewed.svg',
            data: [],
            url: sipUrl.notrenewed,
            text: 'Expired',
            pageTitle: 'Expired SIP',
            toolTipData: 'This report helps you with the list of all the SIP’s of your investors that have been matured till date',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Maturity Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'SIP Amount',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Market Value',
                    logo: 'assets/icon/card/chart-square-grey.svg',
                },
                {
                    name: 'Total Invt. Amt.',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Scheme_Name', 'Matured_Date', 'Sip_Amount', 'Amount_Matured', 'Investment_Amount'],
            actionName: 'RENEW SIP',
            deepLink: false,
        },
        {
            name: 'maturity',
            img: 'assets/icon/wallet-add.svg',
            data: [],
            url: sipUrl.maturity,
            text: 'SIP upcoming for',
            pageTitle: 'SIP Upcoming for Maturity',
            toolTipData: 'This report helps you with the list of all the SIP’s of your investors that are about to mature in the next two months',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Maturity Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'SIP Amount',
                    logo: 'assets/icon/card/cart/coin.svg',
                },
                {
                    name: 'Total Installment',
                    logo: 'assets/icon/reports/sip-report/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Scheme_Name', 'Matured_Date', 'Sip_Amount', 'Total_Installments'],
            actionName: 'RENEW SIP',
            deepLink: false,
        },
        {
            name: 'SIP',
            img: 'assets/icon/rejected-sip.svg',
            data: [],
            url: sipUrl.rejected,
            text: 'Rejected',
            pageTitle: 'Rejected SIP',
            toolTipData: 'This report helps you with the list of SIPs that were rejected in the last two months',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Reject Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'Total Installment',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Scheme_Name', 'Rejected_Date', 'Total_Installments'],
            actionName: 'RESTART SIP',
            deepLink: false,
        },
        {
            name: 'SIP',
            img: 'assets/icon/card/invested.svg',
            investorList: [],
            schemeList: [],
            data: [],
            url: sipUrl.lumpsum,
            text: 'Investors without',
            pageTitle: 'Investors without SIP ',
            toolTipData: 'This report helps you with the list of all the investors who have only lumpsum investments',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Total Market Value',
                    logo: 'assets/icon/card/chart-square-grey.svg',
                },
                {
                    name: 'No. Of Schemes',
                    logo: 'assets/icon/card/schemes.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: [],
            actionName: 'TRANSACT',
            deepLink: false,
        },
    ];
}

export class SIPOpportunityMetaModel extends FormMetaModel {
    constructor() {
        super('SIP Opportunities', '', false, NavigateRoutes.oppotunity);
    }

    initProperties() {
        return {};
    }
}
